import type { Location } from 'react-router-dom'

/**
 * Returns the appropriate base route for shortlist navigation
 * @param location - The current location object
 * @returns '/search' if in search context, empty string otherwise
 */
export const getShortlistBaseRoute = (location?: Location): string => {
  return location?.pathname?.startsWith('/search') ? '/search' : ''
}

/**
 * Returns the root return path for a given pathname.
 * Used by selection modals to redirect back to the originating page.
 */
export const getSelectionReturnPath = (pathname: string): string => {
  return pathname.startsWith('/search/') ? '/search' : '/'
}

/**
 * Returns the selection route base for a given pathname.
 * e.g. '/search/selection' when in search context, '/selection' otherwise.
 */
export const getSelectionBase = (pathname: string): string => {
  return pathname.startsWith('/search/') ? '/search/selection' : '/selection'
}
